import { z } from 'zod';

const planResponseSchemas = {
  getAllPlans: z.object({
    success: z.boolean(),
    statusCode: z.number(),
    message: z.string(),
    plans: z.array(
      z.object({
        status: z.string(),
        offerId: z.number(),
        title: z.string(),
        productid: z.number(),
        offername: z.string(),
        productType: z.string(),
        capacity: z.number(),
        category: z.string(),
        newOfferName: z.string(),
        isILD: z.boolean(),
        isIR: z.boolean(),
      })
    ),
    addonPlans: z.object({
      remainingIRBalance: z.number(),
      plan: z.array(
        z.object({
          status: z.string(),
          offerId: z.number(),
          title: z.string(),
          productid: z.number(),
          offername: z.string(),
          productType: z.string(),
          capacity: z.number(),
          category: z.string(),
          newOfferName: z.string(),
          type: z.string(),
          titleValue: z.number(),
        })
      ),
    }),
  }),
} as const;

export default planResponseSchemas;
